import React, {useEffect, useState} from 'react';
import {Collapse, Nav, Navbar, NavItem, NavLink} from "reactstrap";
import {Link, NavLink as NavLinkRRD} from "react-router-dom";
import completedIcon from "../../assets/img/icons/user/correct.png";

const AssessmentSidebar = (props) => {
    const [collapseOpen, setCollapseOpen] = useState(false);
    const [userType, setUserType] = useState(props.signedInUser.projectType);
    const [activeIcons, setActiveIcons] = useState([]);
    const {routes, logo} = props;

    useEffect(() => {
        let tempArray = [];
        if (userType === "progress") {
            // Step -1
            if (props.userData.eventData?.assessmentName && props.userData.eventData?.assessmentFor) {
                tempArray.push("Game Information");
            }
            // Step - 2
            if (props.userData.eventData?.selectedLevels?.competencies?.length === 4) {
                tempArray.push("Behavioral Competency");
            }
            // Step - 3
            if (props.userData.eventData?.selectedLevels?.games?.length >= 2) {
                tempArray.push("Mini Games");
            }
        } else {
            // Step - 1
            if (props.userData.eventData?.assessmentName && props.userData.eventData?.assessmentFor) {
                tempArray.push("Assessment Information");
            }
            // Step - 2
            if (props.userData.eventData?.selectedLevels?.competencies?.length === 4) {
                tempArray.push("Behavioral Assessment");
            }
            // Step - 3
            if (props.userData.eventData?.selectedLevels?.cognitive?.length === 2) {
                tempArray.push("Cognitive Game");
            }
        }

        // Step - 4
        if (props.userData.eventData?.selectedLevels?.aptitude?.length === 2) {
            tempArray.push("Aptitude Game");
        }

        // Step - 5
        if (props.userData.eventData?.registrationFields?.length >= 1) {
            tempArray.push("Registration Form Fields");
        }

        // Step - 6
        if (props.userData.eventData?.loginMethod?.length >= 1) {
            tempArray.push("Login Method");
        }

        // Step - 7
        if (props.userData.eventData?.companyLogo) {
            tempArray.push("Customize Artwork");
        }

        // Step - 8
        if (props.userData.eventData?.launchDate && props.userData.eventData?.closingDate) {
            tempArray.push("Launch Date & Availability");
        }
        setActiveIcons([...tempArray]);
    }, [props.userData]);

    let navbarBrandProps;
    if (logo && logo.innerLink) {
        navbarBrandProps = {
            to: logo.innerLink,
            tag: Link,
        };
    } else if (logo && logo.outterLink) {
    }

    const getIcon = (count, _route) => {
        if (activeIcons.includes(_route.name)) {
            return (<img alt="" src={completedIcon} className="ml-1"/>)
        } else {
            return (
                <div className="rounded-circle outer-wrapper">
                    <div className="rounded-circle inner-wrapper">
                        <span>{count}</span>
                    </div>
                </div>
            )
        }
    }
    const createLinks = (routes) => {

        return routes.filter(route => route.display).map((prop, key) => {
            return (
                <div key={key}>
                    <NavItem>
                        <NavLink
                            className="text-dark px-3 py-0"
                            to={prop.layout + prop.path}
                            disabled={!activeIcons.includes(prop.name)}
                            tag={NavLinkRRD}
                            // onClick={closeCollapse}
                            activeClassName="activeTab"
                        >
                            <div className="d-flex h-100 align-items-center text-center">
                                <div className="text-right pl-5 pr-4" style={{width: "160px"}}>
                                    {prop.name}
                                </div>
                                <div className="">
                                    {getIcon(key + 1, prop)}
                                </div>
                            </div>
                        </NavLink>
                    </NavItem>
                    {key < routes.length - 1 &&
                        // <NavItem className="d-none d-lg-block">
                        <NavItem className="">
                            <div className="vr"/>
                        </NavItem>
                    }
                </div>
            );
        });
    };
    const toggleCollapse = () => {
        setCollapseOpen((data) => !data);
    };
    return (
        <Navbar
            className="navbar-vertical fixed-left navbar-light shadow-none p-0"
            expand="md"
            id="sidenav-assessment">
            <div>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                >
                    <span className="navbar-toggler-icon"/>
                </button>
                {/*{logo ? (*/}
                {/*    <>*/}
                {/*        <NavbarBrand className="nav-p new-bg" {...navbarBrandProps}>*/}
                {/*            <img*/}
                {/*                alt={logo.imgAlt}*/}
                {/*                className="navbar-brand-img"*/}
                {/*                src={logo.imgSrc}*/}
                {/*            />*/}
                {/*        </NavbarBrand>*/}
                {/*    </>*/}
                {/*) : null}*/}
                {/* Toggler */}
                <Collapse navbar isOpen={collapseOpen} id="assessment-collapse" className="left-content-container">
                    {/* Collapse header */}
                    {/*<div className="navbar-collapse-header d-md-none">*/}
                    {/*    <Row>*/}
                    {/*        {logo ? (*/}
                    {/*            <Col className="collapse-brand" xs="6">*/}
                    {/*                {logo.innerLink ? (*/}
                    {/*                    <Link to={logo.innerLink}>*/}
                    {/*                        <img alt={logo.imgAlt} src={logo.imgSrc}/>*/}
                    {/*                    </Link>*/}
                    {/*                ) : (*/}
                    {/*                    <a href={logo.outterLink}>*/}
                    {/*                        <img alt={logo.imgAlt} src={logo.imgSrc}/>*/}
                    {/*                    </a>*/}
                    {/*                )}*/}
                    {/*            </Col>*/}
                    {/*        ) : null}*/}
                    {/*        <Col className="collapse-close" xs="6">*/}
                    {/*            <button*/}
                    {/*                className="navbar-toggler"*/}
                    {/*                type="button"*/}
                    {/*                onClick={toggleCollapse}*/}
                    {/*            >*/}
                    {/*                <span/>*/}
                    {/*                <span/>*/}
                    {/*            </button>*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*</div>*/}
                    {/* Navigation */}
                    <h3 className="text-center">Journey
                        to {userType === "progress" ? "game" : "assessment"} creation</h3>
                    <Nav id="assessment-nav" navbar>{createLinks(routes)}</Nav>
                </Collapse>
            </div>
        </Navbar>
    );
};

export default AssessmentSidebar;